export const ExportExtensionType = Object.freeze({
  TXT: ".txt",
  DOCX: ".docx",
  PNG: ".png"
})
